exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\r\n  font-size: 14px;\r\n  margin-top: 1rem;\r\n  margin-right: 5px;\r\n  width: 300px;\r\n}\r\n\r\n.alert-container {\r\n  position: fixed;\r\n  top: 45px;\r\n  z-index: 99999;\r\n  right: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/alert/alert.component.css
// module id = ../../../../../src/app/widgets/alert/alert.component.css
// module chunks = main